import { Typography } from '@mui/material'
import { ReactElement } from 'react'
import {
  shouldShowZodFieldError,
  getZodValidationError,
} from 'src/v3/utilities/validation'

type FormFieldErrorProps = {
  fieldMeta: any
  className?: string
}

export default function FormFieldError({
  fieldMeta,
  className = 'mt-1 ml-3.5',
}: FormFieldErrorProps): ReactElement {
  return (
    <Typography
      aria-live="polite"
      variant="caption"
      color="error"
      className={className}
    >
      {shouldShowZodFieldError(fieldMeta)
        ? getZodValidationError(fieldMeta.errors)
        : ''}
    </Typography>
  )
}
